export default {
    delivery: {
        product: {
            tracking: "Monitorando",
            quantity: "Quantidade"
        }
    }
}